import { useFeatureGate } from '@statsig/react-bindings';
import { useAuthUser } from './useAuth';
import { useUserContext } from '@/contexts';

// Orgs explicitly enabled for user management before the Statsig feature flag
// is fully rolled out. The feature flag targets users (not client IDs), so these
// orgs need a code-level override. Remove once the flag covers all target orgs.
const USER_MANAGEMENT_CLIENT_IDS = [
  'client_2SPA32vwNw5gTSC9UiReStKItPA',
  'client_2zFQ7sQdKt7esKysml2vMC4CFrr',
];

/**
 * Returns true if the user management feature is enabled.
 * Access is granted if the org is explicitly enabled, the user_management
 * feature flag is on, OR the user is a Superuser.
 */
export const useUserManagementEnabled = (): boolean => {
  const { value: featureEnabled } = useFeatureGate('user_management');
  const { isSuperUser } = useAuthUser();
  const { clientId } = useUserContext();
  return USER_MANAGEMENT_CLIENT_IDS.includes(clientId) || featureEnabled || isSuperUser;
};
